"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Browser_1 = __importDefault(require("./Browser/Browser"));
var Filter_1 = __importDefault(require("./Filter/Filter"));
var Navigation_1 = __importDefault(require("./Navigation/Navigation"));
var Results_1 = __importDefault(require("./Results/Results"));
var TemplatesService_1 = __importDefault(require("./TemplatesService"));
require("Templates/Templates.ng.html");
exports.default = angular.module("qwilr.templates", ["ui.router"]).config(function ($stateProvider) {
    var applyTemplateUi = function ($scope, $rootScope, templateState) {
        var di = $rootScope.di.child();
        var onUpdateQueue = [];
        var _a = di.make(TemplatesService_1.default), loadTemplates = _a.loadTemplates, getTemplate = _a.getTemplate, updateTemplateState = _a.updateTemplateState, initTemplateState = _a.initTemplateState;
        di.load({
            templateState: templateState,
            getTemplate: function () {
                return getTemplate;
            },
            loadTemplates: function () {
                return loadTemplates;
            },
            updateTemplateState: function () {
                return updateTemplateState(onUpdateQueue);
            },
            initTemplateState: function () {
                return initTemplateState;
            },
        });
        di.invoke(function (make, loadingIndicator, $timeout) {
            loadingIndicator.loading("Templates");
            loadTemplates()
                .then(function () {
                loadingIndicator.hide();
                initTemplateState(templateState);
                var navigation = make(Navigation_1.default);
                onUpdateQueue.push(navigation.refresh);
                var browser = make(Browser_1.default);
                onUpdateQueue.push(browser.refresh);
                var results = make(Results_1.default);
                onUpdateQueue.push(results.refresh);
                var filter = make(Filter_1.default);
                onUpdateQueue.push(filter.refresh);
                $scope.ui = {
                    navigation: navigation.ui,
                    browser: browser.ui,
                    results: results.ui,
                    filter: filter.ui,
                };
                $timeout(function () {
                    if (templateState === null || templateState === void 0 ? void 0 : templateState.projectId) {
                        document.getElementById("template-unit--".concat(templateState.projectId)).scrollIntoView();
                    }
                });
            })
                .catch(function () {
                loadingIndicator.hide();
            });
        });
    };
    $stateProvider
        .state("templateselection", {
        url: "/templateselection?suppressBackButton",
        templateUrl: "Templates/Templates.ng.html",
        controller: function ($scope, $rootScope, $stateParams) {
            applyTemplateUi($scope, $rootScope, $stateParams);
        },
    })
        .state("templatesSearch", {
        url: "/templateselection/search/:searchTerm/:projectId?",
        templateUrl: "Templates/Templates.ng.html",
        controller: function ($scope, $rootScope, $stateParams) {
            applyTemplateUi($scope, $rootScope, $stateParams);
        },
    })
        .state("templatesMy", {
        url: "/templateselection/my-templates/:projectId?",
        templateUrl: "Templates/Templates.ng.html",
        controller: function ($scope, $rootScope, $stateParams) {
            applyTemplateUi($scope, $rootScope, $stateParams);
        },
    })
        .state("templatesRecommended", {
        url: "/templateselection/recommended/:projectId?",
        templateUrl: "Templates/Templates.ng.html",
        controller: function ($scope, $rootScope, $stateParams) {
            applyTemplateUi($scope, $rootScope, $stateParams);
        },
    })
        .state("templatesDropdown", {
        url: "/templateselection/:dropdownItem",
        templateUrl: "Templates/Templates.ng.html",
        controller: function ($scope, $rootScope, $stateParams) {
            applyTemplateUi($scope, $rootScope, $stateParams);
        },
    })
        .state("templatesDropdownUseCase", {
        url: "/templateselection/:dropdownItem/:useCase",
        templateUrl: "Templates/Templates.ng.html",
        controller: function ($scope, $rootScope, $stateParams) {
            applyTemplateUi($scope, $rootScope, $stateParams);
        },
    })
        .state("templatesDropdownUseCaseTile", {
        url: "/templateselection/:dropdownItem/:useCase/:tileId",
        templateUrl: "Templates/Templates.ng.html",
        controller: function ($scope, $rootScope, $stateParams) {
            applyTemplateUi($scope, $rootScope, $stateParams);
        },
    })
        .state("templatesDropdownUseCaseTileProjectId", {
        url: "/templateselection/:dropdownItem/:useCase/:tileId/:projectId?",
        templateUrl: "Templates/Templates.ng.html",
        controller: function ($scope, $rootScope, $stateParams) {
            applyTemplateUi($scope, $rootScope, $stateParams);
        },
    });
});
